import { useEffect, useState} from "react";
import Loading from "../../../component/Loading/Loading";
import "../styles.css";
import {base64DecodeUnicode, toastSuccess} from "../../../assets/functions";
import {getManagerHeader} from "../../Login/functions";
import axios from "axios";
import {baseCmsApiUrl} from "../../../assets/Constants";
import ProductForm from "../component/ProductForm/ProductForm";
import {getProductById} from "../functions";
import {useNavigate, useParams} from "react-router-dom";

const UpdateProduct = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const singleProduct = {
        color: "",
        hexColor: "",
        size: "",
        balance: "",
        activePicture: "",
        customAttributeId1: "",
        valueAttributeId1: "",
        customAttributeId2: "",
        valueAttributeId2: "",
    }
    const returnProduct = {
        maxHoursForNormal: "",
        maxHoursForSilver: "",
        maxHoursForGold: "",
    }
    const price = {
        amount: "",
        discountAmount: "",
        discountPercent: "",
        isClosed: "",
        closedRate: "",
        minimumRate: "",
    };
    const installment = {
        minimumPrePaymentAmount: "",
        minimumPrePaymentPercent: "",
        refundMethod: "MONTHLY",
        maxNumberOfInstallment: "",
        profitAmount: "",
        profitPercent: "",
    };
    const limitation = {
        minOrderNumberForNormal: "",
        minOrderNumberForSilver: "",
        minOrderNumberForGold: "",
        maxOrderNumberForNormal: "",
        maxOrderNumberForSilver: "",
        maxOrderNumberForGold: "",
    };
    const [product , setProduct] = useState({
        sellingTypeId: "1",
        productTypeId: "1",
        pricingMethod: "CONSTANT",
        productCategoryIds: [],
        brandId: "",
        persianName: "",
        persianModel: "",
        englishName: "",
        englishModel: "",
        guarantee: "",
        pictures: [],
        primaryPicture: "",
        videos: [],
        informationTable: [],
        informationText: "",

        singleProducts: [
            {...singleProduct ,
                productPrices : {
                    normalPrice : {...price},
                    silverPrice : {...price},
                    goldPrice : {...price},
                    normalInstallment : {...installment},
                    silverInstallment : {...installment},
                    goldInstallment : {...installment},
                },
                limitation : {...limitation}}],
        currency: {
            id : "1" ,
            name : "تومان" ,
            rate : 1,
        },
        returnProduct : {...returnProduct}

    });

    useEffect(() => {
        (async () => {
            document.title = "ویرایش کالا" ;
            const p = await getProductById(id);
            setProduct({...product , ...p});
            console.log(p);
            setIsLoading(false);
        })();
    }, []);

    const handleSubmit = async () => {
        setIsLoading(true);
        const headers = getManagerHeader();
        console.log(product);
        axios.put(baseCmsApiUrl + 'products', product, {headers})
            .then((response) => {
                console.log(response);
                console.log(response.data);
                toastSuccess(base64DecodeUnicode(response.statusText));
                // navigate("/products");
                return;
            })
            .catch((e) => {
                console.error(e)
                console.log(base64DecodeUnicode(e.response.statusText))
                console.log(e.response.data)
            }).finally(() => {
            setIsLoading(false)
        })
    }


    if (isLoading)
        return <Loading/>

    return (
        <div className="container-fluid p-0">
            <div className="mb-4">
                <h1 className="h3 d-inline align-middle">ویرایش کالا</h1>
            </div>

            <ProductForm product={product} onChange={(value) => {
                setProduct(value);
            }} />

            <button className={"btn btn-secondary btn-lg w-100"} onClick={handleSubmit} disabled={isLoading}>ویرایش کالا</button>
        </div>

    );
};

export default UpdateProduct;